import { Vue } from 'vue-property-decorator';
export const VimeoServiceEvents = new Vue();

class VimeoServiceClass {
    public loaded = false;
    public apiReady = false;
    private baseApi = 'https://vimeo.com/api/oembed.json?width=1280&url=https%3A%2F%2Fvimeo.com%2F';

    public load(): void {
        if (!this.loaded) {
            this.loaded = true;
            this.createApiScript();
        }
    }

    public getBaseApi(): string {
        return this.baseApi;
    }

    private createApiScript(): void {
        let scriptTag = document.createElement('script');
        scriptTag.onload = () => {
            this.apiIsReady();
        }
        scriptTag.src = "//player.vimeo.com/api/player.js";
        let firstScriptTag = document.getElementsByTagName('script')[0];
        if (firstScriptTag && firstScriptTag.parentNode) {
            firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
        }
    }

    private apiIsReady(): void {
        VimeoServiceEvents.$emit('apiReady', true);
        this.apiReady = true;
    }
}

export let VimeoService = new VimeoServiceClass();